(function() {
    'use strict'

    var pluginName = "slickSlider";
    var defaults = {
        slickOptions: {
            dots: true,
            appendDots: $('.js-slick-dots'),

            arrows: true,

            infinite: true,
            lazyLoad: 'progressive',
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                      arrows: false
                    }
                }
            ]
        }
    };

    // Plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);    // merge contents of objects into first object
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    // Plugin Methods
    Plugin.prototype = {
        init() {
            this.$element = $(this.element);
            this.$parent = this.$element.parent();
            this.$images = $('img', this.element);
            this.$prev = $('.js-slick-prev', this.$parent);
            this.$next = $('.js-slick-next', this.$parent);
            this.isInit = false;

            this.initializeSlider();
            this.bindEvents();
        },

        initializeSlider() {
            if (this.isInit === false) {
                this.$element.slick(this.options.slickOptions);
                this.isInit = true;
            }
        },

        showSlide(e, data) {
            const slideIndex = data.slideIndex;
            this.$element.slick('slickGoTo', slideIndex, true);
            this.$element.parents('.js-gallery-slick').addClass('is-active');

            $('.slick-slide.slick-active').eq(0).focus();
        },

        hideSlide() {
            this.closeSlider();
        },

        afterChange(event, slick, currentSlide) {
            if (window.matchMedia) {
                if (window.matchMedia('only screen and (min-width: 901px)').matches) {
                    $('.js-gallery-grid').trigger('replaceImage', {index: currentSlide});

                    if (currentSlide === 0) {
                        this.$prev.addClass('is-hidden');
                    }
                    else {
                        this.$prev.removeClass('is-hidden');
                    }

                    if (slick.slideCount === currentSlide + 1) {
                        this.$next.addClass('is-hidden');
                    }
                    else {
                        this.$next.removeClass('is-hidden');
                    }
                }
            }
        },

        closeSlider() {
            if (window.matchMedia) {
                if (window.matchMedia('only screen and (min-width: 901px)').matches) {
                    this.$element.parents('.js-gallery-slick').removeClass('is-active');
                    $('.js-gallery-grid').trigger('hideImage');
                    $('.js-grid-nav').addClass('is-hidden');
                }
            }
        },

        prev() {
            this.$element.slick('slickPrev');
        },

        next() {
            this.$element.slick('slickNext');
        },

        keyup(event) {
            if (event.keyCode === 27) {
                this.closeSlider();
            }
        },

        // EVENTS
        bindEvents() {
            this.$element.on('showSlide', this.showSlide.bind(this));
            this.$element.on('hideSlide', this.hideSlide.bind(this));
            this.$element.on('afterChange', this.afterChange.bind(this));
            this.$element.on('keyup', this.keyup.bind(this));
            this.$prev.on('click', this.prev.bind(this));
            this.$next.on('click', this.next.bind(this));
            //this.$images.on('click', this.closeSlider.bind(this));
        }
    };

    // Plugin wrapper
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if(!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    }
}());
